import { createRoute } from '@tanstack/react-router';
import { adminParentRoute } from 'pages/admin/adminParentRoute';
import { pageResetMiddleWare, zodOptionalId, zodOptionalString, zodPage } from 'routes/routeUtils';
import { z } from 'zod';

export const adminKopilotInvoicesRoute = createRoute({
  getParentRoute: () => adminParentRoute,
  path: '/kopilot/invoices',
  validateSearch: z.object({
    page: zodPage,
    query: zodOptionalString,
    tab: z.enum(['all', 'ignored', 'incomplete', 'other']).default('all'),
    pharmacyId: zodOptionalId,
    labId: zodOptionalId,
  }),
  search: { middlewares: [pageResetMiddleWare] },
}).lazy(() =>
  import('pages/admin/KopilotInvoices/AdminKopilotInvoicesPage/AdminKopilotInvoicesPage').then(
    (d) => d.Route
  )
);
